import { render, staticRenderFns } from "./logs.page.vue?vue&type=template&id=4a2a0bc8&scoped=true&"
import script from "./logs.page.vue?vue&type=script&lang=js&"
export * from "./logs.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a0bc8",
  null
  
)

export default component.exports